"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _normalizr = require("normalizr");

var linkedBookingSchema = new _normalizr.Schema("linked_bookings");
var bookingSchema = new _normalizr.Schema("booking");

bookingSchema.define({
    linked_bookings: (0, _normalizr.arrayOf)(linkedBookingSchema)
});

exports.default = bookingSchema;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/api/schemas/bookingSchema.js
// module id = 1289
// module chunks = 0